import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { campaignsService } from '@aslanpay/portal-common-lib';

const useDeleteCampaign = (options: UseMutationOptions<void, Error, string>) => {
  return useMutation<void, Error, string>(
    (campaignId) => campaignsService.deleteCampaign(campaignId),
    options
  );
};

export default useDeleteCampaign;
